import styled from 'styled-components';
import { sizes } from 'style';
import { NAVIGATION_HEIGHT, NAVIGATION_HEIGHT_MOBILE } from 'consts';

export const QuestionsContainer = styled.div`
  box-sizing: border-box;
  padding: 20px;
  padding-bottom: 0;

  @media ${sizes.tabletPortrait} {
    padding: 20px 40px;
    padding-bottom: 0;
  }

  @media ${sizes.desktop} {
    padding: 50px;
    padding-bottom: 0;
  }
`;

export const Category = styled.div`
  :not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.pink};
  }

  :not(:last-child) {
    margin-bottom: 60px;
  }

  :last-child {
    min-height: calc(100vh - ${NAVIGATION_HEIGHT_MOBILE}px - 60px);

    @media ${sizes.tabletPortrait} {
      min-height: calc(100vh - ${NAVIGATION_HEIGHT}px - 60px);
    }
  }
`;

export const NoResults = styled.h3`
  margin: 0;
`;
